module.exports = __webpack_public_path__ + "img/platform-B.bf9f5585.jpg";